export enum EconomicEntryDefaultCode {
  NoCompetence = 'NCSPC'
}
